import http from '@/plugins/api'
import { startLoading } from '@/plugins/loading'
import * as types from './types'

export default {
  setSearchTerm({ commit }, text) {
    commit(types.SET_SEARCH_TERM, text)
  },
  setPageSize({ commit }, pageSize) {
    commit(types.SET_PAGE_SIZE, pageSize)
  },
  setSortDir({ commit }, sortDir) {
    commit(types.SET_SORT_DIR, sortDir)
  },
  setOrderBy({ commit }, orderBy) {
    commit(types.SET_ORDER_BY, orderBy)
  },
  setFilterBy({ commit }, filterBy) {
    commit(types.SET_FILTER_BY, filterBy)
  },
  setFilterOptions({ commit }, data) {
    commit(types.SET_FILTER_OPTIONS, data)
  },
  initLocations({ commit }) {
    commit(types.SET_LOCATIONS_FOUND, null)
  },
  resetPreferences({ commit }, data) {
    commit(types.RESET_PREFERENCES, data)
  },
  updatePreference({ commit }, data) {
    commit(types.UPDATE_PREFERENCE, data)
  },
  pushLocation({ commit }, data) {
    commit(types.PUSH_LOCATION, data)
  },
  popLocation({ commit }) {
    commit(types.POP_LOCATION)
  },
  pushInsurance({ commit }, data) {
    commit(types.PUSH_INSURANCE, data)
  },
  popInsurance({ commit }, id) {
    commit(types.POP_INSURANCE, id)
  },
  setInsuranceData({ commit }, data) {
    commit(types.SET_INSURANCE_DATA, data)
  },
  resetProviders({ commit }) {
    commit(types.RESET_PROVIDERS)
  },
  resetSearch({ commit }) {
    commit(types.RESET_SEARCH)
  },
  pushProvider({ commit }, data) {
    commit(types.PUSH_PROVIDER, data)
  },
  popProvider({ commit }, id) {
    commit(types.POP_PROVIDER, id)
  },
  setProviderData({ commit }, data) {
    commit(types.SET_PROVIDER_DATA, data)
  },
  resetAddLocation({ commit }) {
    commit(types.RESET_ADD_LOCATION)
  },
  setAddLocation({ commit }, data) {
    commit(types.SET_ADD_LOCATION, data)
  },
  resetPrices({ commit }) {
    commit(types.RESET_PRICING)
  },
  setFoundProvider({ commit }, data) {
    commit(types.SET_FOUNDPROVIDER_DATA, data)
  },
  async searchFirms({ commit, dispatch }, options) {
    const r = await startLoading(dispatch, 'searchFirms', () =>
      http.get(`firm/firmAdvancedSearch?searchterm=${options.searchterm}&type=${options.type}`)
    )
    commit(types.SET_FOUND_LOCATIONS, r.data)
    return r.data
  },
  async getNetworkTree({ commit, dispatch }, data) {
    const r = await startLoading(dispatch, 'getNetworkTree', () =>
      http.get(`firm/locationTree?id=${data.id}&firm=${data.firm}&showInactive=${data.showInactive}`)
    )
    commit(types.SET_NETWORK_TREE, r.data)
    return r.data
  },
  async getLocationTree({ commit, dispatch }, data) {
    const r = await startLoading(dispatch, 'getLocationTree', () => http.get(`firm/locationTree?id=${data.id}&firm=${data.firm}`))
    commit(types.SET_LOCATION_TREE, r.data)
    return r.data
  },
  async getLocations({ commit, dispatch }, searchOptions) {
    const r = await startLoading(dispatch, 'getLocations', () =>
      http.get('firm/getFirms', {
        params: searchOptions
      })
    )
    commit(types.SET_LOCATIONS, r.data)
    return r.data
  },
  async getLocation({ commit, dispatch }, id) {
    const r = await startLoading(dispatch, 'getLocation', () => http.get(`firm/firm?firm=${id}`))
    commit(types.SET_LOCATION, r.data)
    return r.data
  },
  async saveLocation({ commit, dispatch }, data) {
    const r = await startLoading(dispatch, 'saveLocation', () => http.post('firm/saveFirm', data))
    return r.data
  },
  async removeLocation({ commit, dispatch }, data) {
    const r = await startLoading(dispatch, 'removeLocation', () => http.post('firm/removeFirm', data))
    return r.data
  },
  async searchLocations({ commit, dispatch }, search) {
    let _firms = []
    if (search !== undefined && search !== null) {
      if (search.searchterm !== '') {
        let url = ''
        url = `firm/firmSearch/?firm=${search.firm}&searchterm=${search.searchterm}`
        let data = await http.get(url)
        if (data !== undefined && data !== null) {
          if (data.data !== undefined && data.data !== null) {
            for (let item of data.data) {
              let firm = {
                firm: item.firm,
                name: item.firmName
              }
              _firms.push(firm)
            }
          }
        }
        commit(types.SET_LOCATIONS_FOUND, _firms)
      }
    }
    return _firms
  },
  async getPreferences({ commit, dispatch }, data) {
    const r = await startLoading(dispatch, 'getPreferences', () =>
      http.get('firm/firmPreference', {
        params: data
      })
    )
    commit(types.SET_PREFERENCES, r.data)
    return r.data
  },
  // Fetch a firm's preference(s) and RETURN them WITHOUT committing to the shared
  // `preferences` store. Use this when a component needs another firm's preference (e.g. the
  // inspection's owning firm, not the logged-in user's firm) so it does not overwrite/append
  // to the profile-firm preferences the dashboard relies on (SET_PREFERENCES concatenates).
  async getFirmPreference({ dispatch }, data) {
    const r = await startLoading(dispatch, 'getFirmPreference', () =>
      http.get('firm/firmPreference', {
        params: data
      })
    )
    return r.data
  },
  async savePreferences({ commit, state, dispatch }) {
    state.preferences.forEach((element) => {
      if (element.changed) {
        let data = {
          firm: element.firm,
          firmPreferenceName: element.name,
          preference: element.value,
          firmPreferenceCategory: element.type
        }
        http.post('firm/saveFirmPreference', data)
      }
    })
    commit(types.RESET_PREFERENCE_CHANGE)
  },
  // Cascade a single preference (e.g. reportType) to the selected node and every
  // descendant location. data = { firm, firmPreferenceName, preference, firmPreferenceCategory }
  async savePreferenceToChildren({ commit, dispatch }, data) {
    const r = await startLoading(dispatch, 'savePreferenceToChildren', () =>
      http.post('firm/saveFirmPreferenceToChildren', data)
    )
    return r.data
  },
  async updateFirmSettings({ commit, dispatch }, data) {
    const r = await startLoading(dispatch, 'updateFirmSettings', () => http.post('firm/updateFirmSettings', data))
    return r.data
  },
  async searchInsurance({ commit, dispatch }, search) {
    let _firms = []
    if (search !== undefined && search !== null) {
      if (search.searchterm !== '') {
        let url = ''
        url = `firm/searchForOptInPrograms/?firm=${search.firm}&search=${search.searchterm}`
        let data = await http.get(url)
        if (data !== undefined && data !== null) {
          if (data.data !== undefined && data.data !== null) {
            for (let item of data.data) {
              let firm = {
                firm: item.firm,
                name: item.firmName,
                license: item.license
              }
              _firms.push(firm)
            }
          }
        }
        commit(types.SET_INSURANCE_FOUND, _firms)
      }
    }
    return _firms
  },
  async getInsurance({ commit, dispatch }, data) {
    const r = await startLoading(dispatch, 'getInsurance', () => http.get(`firm/optInPrograms?firm=${data.firm}&isSave=${data.isSave}`))
    console.log('Got Insurance', r.data)
    if (r.data === undefined || r.data === null) {
      r.data = []
    } else if (r.data === '') {
      r.data = []
    }
    commit(types.SET_INSURANCE, r.data)
    return r.data
  },
  async saveInsurance({ commit, state }) {
    http.post('firm/saveOptInPrograms', state.insurance)
  },
  async searchProvider({ commit, dispatch }, search) {
    let _firms = []
    if (search !== undefined && search !== null) {
      let url = ''
      url = `firm/searchForProviders/?firm=${search.firm}&search=${search.searchterm}&postalcode=${search.postalCode}&radius=${search.radius}`
      let data = await http.get(url)
      if (data !== undefined && data !== null) {
        if (data.data !== undefined && data.data !== null) {
          for (let item of data.data) {
            let firm = {
              firm: item.firm,
              name: item.firmName,
              license: item.license,
              postalCode: item.postalCode,
              addressLines: item.addressLines,
              city: item.city,
              state: item.state,
              phone: item.phone,
              isOptIn: false,
              relationship: item.relationship,
              firmClass: item.firmClass,
              longitude: item.longitude,
              latitude: item.latitude,
              reviewAverage: item.reviewAverage,
              reviewCount: item.reviewCount
            }
            _firms.push(firm)
          }
        }
      }
      commit(types.SET_PROVIDER_FOUND, _firms)
    }
    return _firms
  },
  async getProviders({ commit, dispatch }, data) {
    commit(types.RESET_PROVIDERS)
    const r = await startLoading(dispatch, 'getProviders', () => http.get(`firm/providers?firm=${data.firm}&isSave=${data.isSave}`))
    console.log('Got Providers', r.data)
    if (r.data === undefined || r.data === null) {
      r.data = []
    } else if (r.data === '') {
      r.data = []
    }
    commit(types.SET_PROVIDERS, r.data)
    return r.data
  },
  async saveProviders({ commit, state }) {
    console.log('Saving Providers', state.providers)
    const relationship5 = state.providers.filter((item) => item.relationship === 5)
    http.post('firm/saveProviders', relationship5)
  },
  async getCalibrationPricing({ commit, dispatch }, data) {
    const r = await startLoading(dispatch, 'getCalibrationPricing', () =>
      http.get(`adasmatrix/getCalibrationPricing?firm=${data.firm}&calibrationType=${data.calibrationType}`)
    )
    console.log('Got Calibration Pricing', r.data)
    if (r.data === undefined || r.data === null) {
      r.data = []
    } else if (r.data === '') {
      r.data = []
    }
    commit(types.SET_PRICING, r.data)
    return r.data
  },
  async saveCalibrationPricing({ commit, state }, data) {
    http.post('adasmatrix/saveCalibrationPricing', data)
  },
  async importCalibrationPricing({ commit, dispatch }, data) {
    http.post('adasmatrix/importCalibrationPricing', data)
  },
  async exportCalibrationPricing({ commit, dispatch }, firm) {
    return http.get(`adasmatrix/exportCalibrationPricing?firm=${firm}`)
  },
  async getProviderProfile({ commit, dispatch }, launchpadFirmId) {
    const r = await startLoading(dispatch, 'getProviderProfile', () =>
      http.get('firm/getProviderProfile', {
        params: { launchpadFirmId }
      })
    )
    console.log('Got Provider Profile', r.data)
    commit(types.SET_PROVIDER_PROFILE, r.data)
    return r.data
  },
  async getProviderReviews({ commit, dispatch }, launchpadFirmId) {
    const r = await startLoading(dispatch, 'getProviderReviews', () =>
      http.get('firm/getProviderReviews', {
        params: { launchpadFirmId }
      })
    )
    console.log('Got Provider Reviews', r.data)
    commit(types.SET_PROVIDER_REVIEWS, r.data)
    return r.data
  },
  async getLookupOptions({ commit, dispatch }) {
    const [serviceMethods, serviceList, trainingCertifications] = await Promise.all([
      http.get('lookup/serviceMethodOptions'),
      http.get('lookup/serviceListOptions'),
      http.get('lookup/trainingCertificationOptions')
    ])
    return {
      serviceMethodOptions: serviceMethods.data || [],
      serviceListOptions: serviceList.data || [],
      trainingCertificationOptions: trainingCertifications.data || []
    }
  },
  resetProviderProfile({ commit }) {
    commit(types.RESET_PROVIDER_PROFILE)
  }
}



// WEBPACK FOOTER //
// ./src/store/modules/locations/actions.js